import axios from 'axios';
import { ELSKeys } from 'ts/enums';

const BASE_URL = 'https://final-task-backend-production-103d.up.railway.app/';
export const $api = axios.create({
  baseURL: BASE_URL,
});

$api.interceptors.request.use((config) => {
  if (config && config.headers) {
    config.headers.Authorization = `Bearer ${localStorage.getItem(ELSKeys.token)}`;
    config.headers.initUser = `${localStorage.getItem(ELSKeys.userID)}`;
  }
  return config;
});
